/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */
const styles = theme => ({
  subtitle1: {
    color: '#595B61',
    fontSize: '14px',
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      fontSize: '0.875rem',
    },
  },
  marginBttom4pxForArabicLabels: {
    marginBottom: '4px',
  },
  textTransform: {
    textTransform: 'lowercase',
    '& > span': {
      display: 'inline-block',
      '&::first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  body1: {
    color: '#130F26',
    fontSize: '1rem',
    fontWeight: '600',
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
  },
  textAr: {
    fontFamily: '"madani", sans-serif',
    lineHeight: '18px',
  },
});

export default styles;
